module.exports = __webpack_public_path__ + "img/quickblue-responsive.ba5eed7f.png";